import type { DomainPublic, FeaturedToken } from '@creator/sdk/modules/domain/domain.model';
import { getDomainName } from '@src/config';
import { type Action, action, type Computed, computed, type Thunk, thunk } from 'easy-peasy';
import type { StoreModel, StoreModelSetPayload } from '..';
import { loadPublicData } from './actions';

export interface DomainModel {
    publicData: { [id: string]: DomainPublic };
    set: Action<DomainModel, StoreModelSetPayload<string>>;
    setPublicData: Action<DomainModel, DomainPublic>;

    getPublicData: Computed<DomainModel, (id: string) => DomainPublic | undefined>;
    getFeaturedTokens: Computed<DomainModel, () => FeaturedToken[]>;

    loadPublicData: Thunk<DomainModel, string, any, StoreModel, Promise<DomainPublic | undefined>>;
    loadFeaturedTokens: Thunk<DomainModel, string, any, StoreModel>;
}

const DomainModel: DomainModel = {
    publicData: {},

    getPublicData: computed(state => id => state.publicData[id]),
    getFeaturedTokens: computed(state => () => state.publicData[getDomainName()]?.featuredTokens || []),

    setPublicData: action((state, payload) => {
        state.publicData[payload.id] = payload;
    }),

    set: action((state, payload) => {
        const { key, value } = payload;
        state[key] = value;
    }),

    loadPublicData: thunk(async (actions, id, helpers) => {
        const publicData = await loadPublicData(id);
        if (!publicData) return;

        actions.setPublicData(publicData);

        return publicData;
    }),

    loadFeaturedTokens: thunk(async (actions, id, helpers) => {
        const publicData = helpers.getState().getPublicData(id);
        if (!publicData) return;
        const tokenNames = publicData.featuredTokens.map(featuredToken => featuredToken.tokenName);
        return helpers.getStoreActions().token.loadTokensByTokenNames(tokenNames);
    }),
};

export default DomainModel;
